import React from 'react';
import Navbar from '../../components/Navbar';
import SidebarSeccion from '../../components/SidebarSeccion';
import { getTema } from '../../theme';

export default function HallFama({ tipo, nivel }) {
  const tema = getTema(tipo);

  return (
    <div style={{ minHeight: '100vh', background: tema.bg }}>
      <Navbar tema={tema} titulo={tipo === 'militar' ? 'Programa Militar' : 'Inglés Civil'} tipo={tipo} nivel={nivel} />
      <div className="page-layout">
        <SidebarSeccion tema={tema} tipo={tipo} nivel={nivel} />
        <main className="page-content">
          <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center' }}>
            <div style={{ fontSize: '80px', marginBottom: '24px', filter: 'drop-shadow(0 4px 16px rgba(255,215,0,0.4))' }}>🏆</div>
            <h2 style={{ color: tema.text, fontSize: '32px', fontWeight: 800, fontFamily: 'Inter, sans-serif', marginBottom: '12px' }}>
              Hall de la Fama
            </h2>
            <p style={{ color: tema.muted, fontSize: '15px', maxWidth: '360px', lineHeight: 1.6 }}>
              Próximamente — aquí aparecerán los mejores alumnos de {nivel}.
            </p>
          </div>
        </main>
      </div>
    </div>
  );
}
